<template>
  <base-modal size="lg" hide-footer hide-header @close="close">
    <div class="col-12" @click.stop="">
      <h3 class="text-center">
        {{ item.name }}
      </h3>
      <marker-editor-map
        v-if="item"
        :id="item.id"
        class="item-map"
        :lat="parseFloat(item.lat)"
        :lon="parseFloat(item.lon)"
        :type="BRIDGE"
        :draggable="false"
      />

      <div class="px-2">
        <div class="row">
          <div class="col-6 nopads">
            <span class="item-detail-title">{{ $t('bridge.name') }}</span>
            <span class="item-detail-text">{{ item.name }}</span>
          </div>
          <div class="col-6 nopads">
            <span class="item-detail-title">{{ $t('bridge.code') }}</span>
            <span class="item-detail-text">{{ item.code }}</span>
          </div>
        </div>
        <div class="row">
          <div class="col-6 nopads">
            <span class="item-detail-title">{{ $t('bridge.owner') }}</span>
            <span class="item-detail-text">{{ item.owner }}</span>
          </div>
          <div class="col-6 nopads">
            <span class="item-detail-title">{{ $t('bridge.maintainer') }}</span>
            <span class="item-detail-text">{{ item.maintainer }}</span>
          </div>
        </div>
        <div class="row">
          <div class="col-6 nopads">
            <span class="item-detail-title">{{ $t('bridge.road_num') }}</span>
            <span class="item-detail-text">{{ item.roadNum }}</span>
          </div>
          <div class="col-6 nopads">
            <span class="item-detail-title">{{ $t('bridge.sec_num') }}</span>
            <span class="item-detail-text">{{ item.secNum }}</span>
          </div>
        </div>
        <div class="row">
          <div class="col-6 nopads">
            <span class="item-detail-title">{{ $t('orders.status') }}</span>
            <span class="item-detail-text">{{ item.status }}</span>
          </div>
        </div>
      </div>

      <div class="button-container col-sm-12">
        <button class="btn btn-success form-button" @click.stop="changeView">
          {{ $t('menu.new_inspection') }}
        </button>
        <button class="btn btn-secondary form-button" @click.stop="close">
          {{ $t('common.close') }}
        </button>
      </div>
    </div>
  </base-modal>
</template>

<script>
import MarkerEditorMap from '../map/MarkerEditorMap'
import {mapHelper} from "@/components/mixins/MapMixin";
import BaseModal from "@/components/BaseModal";

export default {
    name: 'BridgeDetails',
    components: {BaseModal, MarkerEditorMap},
    mixins: [mapHelper],
    props: {
        item: {
            type: Object,
            default: null
        },
        setInspectionParams: {
            type: Function,
            default: null
        }
    },
    data() {
        return {
            map: null,
            mapHelper
        }
    },
    emits: ['inspection'],
    methods: {
        close: function () {
            this.$emit('close')
        },
        changeView: function () {
            this.$emit('inspection', this.item);
        }
    }
}
</script>

<style scoped>
.map-container {
    height: 30em;
    position: relative;
}

</style>
